import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as S from './ThankyouPageStyle';
import ThankyouSuccess from './ThankyouSucess/ThankyouSuccess'
import ThankyouFailed from './ThankyouFailed';
import Footer from './Footer/Footer';
import { footerSelector } from './../Common/redux/selectors';
import MobileHeader from './ThankyouSucess/MobileHeader';
import { fetchJourneyDetails } from './redux/thunks';
import { thankyouInfoSelector, getBookingStatusSelector, getPaymentStatusSelector, getThankyouPageError } from './redux/selectors';
import { IUserStoreState, userSelector } from '@stencil/user-reducer';
import Popup from './../../../stories/core-components/Popup/Popup';
import { pushEcommerceGAEvent } from 'ga-utils';
import { getter } from '@stencil/client-side-storage';
import LineLoader from './Loader/Loader';
import { pushOmniEvents } from '../../utils/PushEvents/Omniture/utils';
import { pushWebEngageEvents } from '../../utils/PushEvents/WebEngage/utils';
import { THANKYOU_PAGE } from '../../utils/PushEvents/Omniture/constants';
import { getSessionStorage, isMobileView } from '../Common/Utils';
import { userLoyaltyInfo } from '../Home/redux/selectors';
import dateFormat from 'dateformat';
import { getPokusKeys } from '../../pages/StoriesTestPage/SrpPage/SrpMainBlock/utils';
import { pushHashedEmailIntoGtm } from './Utils';
const ThankyouPage = props => {

  const dispatch = useDispatch();
  const [popupContent, setPopupContent] = useState({ title: '', content: '' });
  const footer_data = useSelector(footerSelector);
  const thankyouInfo = useSelector(thankyouInfoSelector);
  const bookingStatus = useSelector(getBookingStatusSelector);
  const paymentStatus = useSelector(getPaymentStatusSelector);
  const isError = useSelector(getThankyouPageError);
  const userDetails = useSelector(userSelector) as IUserStoreState;
  const isLoggedIn = !!userDetails?.isLoggedIn;
  const {userInfo, loyaltyInfo={}} = userDetails;
  const { txnid } = thankyouInfo
  const busRatingShown = getter('bus_rating_shown') || {};
  const feedbackStatus = busRatingShown[txnid] || false;
  const userLoyalty = useSelector(userLoyaltyInfo)
  const userTier = userLoyalty?.userLoyaltyInfo?.user_tier === undefined ? '' : `${userLoyalty?.userLoyaltyInfo?.user_tier}`
  useEffect(() => {
    dispatch(fetchJourneyDetails({}));
  }, []);

  const getAbVariantFromSession = (key) => {
    if(typeof window !== 'undefined'){
      let keyData= JSON.parse(sessionStorage.getItem(key));
      return keyData && Object.keys(keyData).length > 0 ? getPokusKeys(keyData) : ''
    }
  }

  useEffect(() => {
    if (thankyouInfo && Object.keys(thankyouInfo).length) {
      try {
        const { bookingList=[], txnid, flavour, amt, paxcount, coupon, update_obj, promocode} = thankyouInfo;
        const bookingItem = bookingList && bookingList[0];
        const {src, des, routeCity, depDate, arrTime, depTime, busName, boardAt, po, daysToTrip, duration, droppingPoint, baseFare, taxAmount, seat, seatNumber, discount, finalBookingValue, insuranceSelected, routeState, omnitureData={}} = bookingItem
        const {isAssured=false , isInsured=false} = omnitureData
        const eventDetails = {
          page: {
            pageInfo: {
              section: "domestic bus funnel",
              pageName: "funnel:domestic bus:thankyou",
              pageType: "funnel",
              lob: "domestic bus",
              siteName: isMobileView()?'mWeb':'dWeb',
              platform: 'GI',
              flow: "direct-bus",
              loadedComponents: '',
              abVariant: getAbVariantFromSession('abVariant'),
              deviceId: "",
              loyaltyStatus_v44:`${getSessionStorage('loyaltyInfo') || ''}`,
            },
          },
          account: {
            accountInfo: {
              custID: userInfo?.userid ? `${userInfo?.userid}` : '',
              loginStatus: isLoggedIn?"Logged-In" : "Guest",
              goCash: userDetails?.gocashInfo ? `${userDetails?.gocashInfo?.data?.t_amt}` : "",
              loyaltyStatus: userTier,
              hydraSegment: "",
            },
          },
          productListItems: [{
            SKU: update_obj.bid,
            productInfo: {
                productName: `${busName}`,
            }
          }],
          booking: {
            routeCity: `${routeCity}`,
            routeState: `${routeState}`,
            daysToTrip: `${daysToTrip}`,
            departureDate: `${depDate?depDate.slice(0,10):''}`,
            departureTime: `${depTime}`,
            droppingTime: `${arrTime}`,
            duration: `${duration}`,
            boardingPoint: `${boardAt}`,
            droppingPoint: `${droppingPoint}`,
            baseFare: `${baseFare}`,
            numberOfSeats: `${seat}`,
            seatNumber: `${seatNumber}`,
            taxAmount: `${taxAmount}`,
            discount: `${Math.round(discount)}`,
            finalBookingValue: `${finalBookingValue}`,
            promocode: `${promocode}`,
            insuranceSelected: `${insuranceSelected ? 'Y' : 'N'}`,
            paymentMethod: "",
            paymentStatus: `${paymentStatus}`,
            bookingId: `${po}`,
            bookingTags: getPokusKeys({Assurance : isAssured, Insurance: isInsured})
          }
        };
        // console.log("Page View Event");
        pushOmniEvents({eventName : 'pageView', details : eventDetails})
        pushEcommerceGAEvent({
          pageViewEvents: {
            ecommerce: {
              purchase: {
                actionField: {
                  action: 'purchase',
                  affiliation: 'goibibo',
                  coupon: coupon || '',
                  id: txnid,
                  revenue: amt,
                  shipping: '',
                  tax: ''
                },
                products: [{
                  brand: `bus|${busName}`,
                  category: "bus_domestic",
                  coupon: coupon || '',
                  id: `bus|${busName}|${src}-${des}`,
                  name: `bus|${src}-${des}`,
                  price: amt,
                  quantity: paxcount,
                  variant: "bus|Onward"
                }]
              }
            }
          },
          event: "enhanced-ecommerce-thankyou",
          virtualPage: `thankyoupage?flavour=${flavour}`,
          path: location ? location.pathname : '/bus/thankyou/'
        });
        
        let webEngageEvtDetails = {
          fb_bus_selected_total_seats:`${seat}`,
          fb_arrival_time: `${arrTime}`,
          fb_arrival_date:`${depDate?dateFormat(depDate.slice(0,10), 'yyyymmdd'):''}`,
          fb_departing_departure_time:`${depTime}`,
          fb_order_id: `${po}`,
          fb_returning_dropping_point:'',
          fb_platform:'GI',
          fb_purchase_value:`${finalBookingValue}`,
          fb_origin:`${src}`,
          fb_destination:`${des}`,
          fb_departing_departure_date:'',
        }
        pushWebEngageEvents({eventName : 'googleRT', details : webEngageEvtDetails})
        pushHashedEmailIntoGtm(update_obj?.email)
      } catch (e) {
      }
    }
  }, [thankyouInfo])

  return (
    <div style={{ backgroundColor: 'white' }}>
      <MobileHeader></MobileHeader>
      {popupContent && Object.keys(popupContent).length && popupContent.content ? (
        <Popup
          title={popupContent.title}
          content={[
            <div
              key="reviewPopupContent"
              dangerouslySetInnerHTML={{ __html: popupContent.content }}
            ></div>,
          ]}
          onCloseClick={() => {
            setPopupContent({ title: '', content: '' });
          }}
        ></Popup>
      ) : <></>}

      {thankyouInfo && Object.keys(thankyouInfo).length ?
        <S.Container>
          {paymentStatus == 'success' && !isError ?
            <ThankyouSuccess thankyouInfo={thankyouInfo} isLoggedIn={isLoggedIn} bookingStatus={bookingStatus} popupContent={popupContent} setPopupContent={setPopupContent} feedbackStatus={feedbackStatus}></ThankyouSuccess>
            :
            <ThankyouFailed thankyouInfo={thankyouInfo} isError={false}></ThankyouFailed>
          }
        </S.Container>
        :
        <LineLoader></LineLoader>}
      <Footer data={footer_data && footer_data.length ? footer_data : []}></Footer>
    </div>
  )
}

export default ThankyouPage;
